export const DELIVERY_ISSUE = 'DELIVERY_ISSUE';
export const RETURN_FROM_CUSTOMER = 'RETURN_FROM_CUSTOMER';
export const USED_OTHER_DELIVERY_WITH_DETAILS = 'USED_OTHER_DELIVERY_WITH_DETAILS';
